module.exports = __webpack_public_path__ + "img/image (9).59bf25c3.png";